import axios from 'axios';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';

export function callApi(postObject: Request): Promise<Optional<ResponseData>> {
	const url = `${SERVICEBASEURL.USER}/IdentityProvider/ExchangeAuthorizationCode`;
	return axios.post(url, postObject).toOptionalMapped((x) => x.data);
}

export interface Request {
	code: string;
	state: string;
}

export interface Response {
	data: ResponseData;
}

export interface ResponseData {
	accessToken: Token;
	refreshToken: Token;
	externalAuthentication: ExternalAuthentication;
}

export interface Token {
	token: string;
	expiresAtUnixTimestamp: number;
}

export interface ExternalAuthentication {
	identityProviderId: string;
	expiresAtUnixTimestamp: number;
}
